import $ from 'jquery';

const validate = (field, value) => {
    // console.log(field, value);
    switch (field) {
        case 'first_name':
            if (!value) {
                return 'First Name is Required';
            }
            break;
        case 'last_name':
            if (!value) {
                return 'Last Name is Required';
            }
            break;
        case 'phone':
            if (!value || value.length != 14) {
                return 'Phone Number is required';
            }
            break;
        case 'phone_extension':
            if (!value || value.length < 2) {
                return 'Phone Extension is required';
            }
            if (value[0] != '+') {
                return 'Please use a correct extension!';

            }
            break;
        case 'email':
            const pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
            if (!value) {
                return 'The E-Mail Address is required';
            } else if (!pattern.test(value)) {
                return 'The E-Mail Address is invalid';
            }
            break;


        case 'business_dba':
            if (!value) {
                return 'Doing Business as is required';
            }
            break;
        case 'business_legal_name':
            if (!value) {
                return 'Legal Business name is Required';
            }
            break;

        case 'business_ownership':
            if (!value) {
                return 'Business Ownership is required';
            }
            break;
        case 'business_address':
            if (!value) {
                return 'Business address is required';
            }
            break;
        case 'address':
            if (!value) {
                return 'Owner Address is required';
            }
            break;

        case 'business_city':
            if (!value) {
                return 'Business city is required';
            }
            break;
        case 'business_state':
            if (!value) {
                return 'Business state is required';
            }
            break;


        case 'business_active_years':
            if (!value) {
                return 'Active years is required';
            } else if (value > 100) {
                return 'Active years cannot exceed 100';

            }
            break;
        case 'business_active_months':
            if (!value) {
                return 'Active months is required';
            } else if (value > 12) {
                return 'Active months cannot exceed 12';

            }
            break;
        case 'website':
            let $el = document.querySelector(".website_field");
            if ($el && $el.hasAttribute("data-required")) {

                if (!value) {
                    return 'Website is required';
                }

            }
            break;


        case 'accept_payment_methods':
            if (!value) {
                return 'Please choose how you will be accepting payments';
            }
            break
        case 'business_avrg_sale_amount':
            if (!value) {
                return 'Average Sale Amount is Required';
            }
            break;
        case 'business_high_sale_amount':
            if (!value) {
                return 'High Sale Amount is Required';
            }
            break;
        case 'business_monthly_volume':
            if (!value) {
                return 'Monthly volume is Required';
            }
            break;

        case 'business_bank_routing_nr':
            // console.log(value.length);
            if (!value) {
                return 'Bank Routing nr is Required';
            }
            if (value.length != 9) {
                return 'Bank Routing nr is invalid';

            }
            break;
        case 'business_bank_account_nr':

            if (!value) {
                return 'Bank Account is Required';
            }
            break;
        case 'business_bank_name':
            if (!value) {
                return 'Bank Name is Required';
            }
            break;
        case 'ssn':
            if (!value || value === '') {
                return 'The Social Security Number is Required';
            }
            if (!isValidSSN(value)) {
                return 'The Social Security Number is Invalid';

            }
            break;


        // case 'hasFTID':

        //     let $elem = document.querySelector(".hasFTID:checked");
        //     if ($elem) {
        //         // console.log($elem);
        //         if (!value || value === '') {
        //             return 'Please state if you have a federal tax id or not';
        //         }
        //     } else {
        //         return 'Please state if you have a federal tax id or not';
        //     }
        //     break;
        case 'has_fid':
            var $element = $(`input[name="has_fid"]:checked`);
            // console.log($element);
            if ($element.length == 0) {
                $("#fid_col").addClass('is-invalid');
                return 'Please select The Federal Tax id';
            }
            break;
        case 'business_type':
            var $element = $(`input[name="business_type"]:checked`);
            if ($element.length == 0) {
                $("#biz_col").addClass('is-invalid');
                return 'Please select The Business Premises';
            }
            break;
        case 'ownership_perc':
            var $element = $(`input[name="ownership_perc"]:checked`);
            if ($element.length == 0) {
                $("#perc_col").addClass('is-invalid');
                return 'Please select your ownership percentage';
            }
            break;
        case 'ownership_percentage':
            // console.log(value)
            if (!value) {
                var $element = $(`input[name="ownership_perc"]:checked`);
                if ($element.length == 0) {
                    $("#perc_col").addClass('is-invalid');
                    return 'Please choose your ownership type';
                }

                // $("#perc_col").addClass('is-invalid');

                return 'Please select your ownership percentage';
            } else {
                $("#perc_col").removeClass('is-invalid');

            }
            break;

        case 'business_federal_tax_id':
            var $isReq = document.getElementsByName(field)[0].dataset.required;
            if ($isReq == 'true') {
                if (!value || value === '') {
                    return 'The Federal Tax id is Required';
                } else if (value.length != 9) {
                    return 'The Federal Tax id is invalid';
                }
            }
            break;

        case 'kyc_license':
            if (!value) {
                return 'The Driver\'s license is required!';
            }
            let $sizeResult = isLowerThan(value, 25);
            if ($sizeResult) {
                return $sizeResult;
            }
            if (!isImage(value)) {
                return `Only images of type jpg, png or pdf files are accepted`;
            }
            break;
        case 'kyc_voided':
            if (!value) {
                return 'The Voided Business check is required!';
            }
            let $sizeResult2 = isLowerThan(value, 25);
            if ($sizeResult2) {
                return $sizeResult2;
            }
            break;
        case 'kyc_businessLicense':
            if (!value) {
                return 'The Business license is required!';
            }
            let $sizeResult3 = isLowerThan(value, 25);
            if ($sizeResult3) {
                return $sizeResult3;
            }
            break;
        case 'business_type':
            if (!value) {
                return 'Business Type is required';
            }
            break;


        case 'business_city': case 'city': case 'city_2':
            if (!value) {
                return 'City is Required';
            }
            break;
        case 'business_state': case 'state': case 'state_2':
            if (!value) {
                return 'State is Required';
            }
            break;
        case 'business_zip': case 'zip': case 'zip_2':
            // console.log(value.length)
            if (!value || value.length != 5) {
                return 'Zip is Required';
            }
            break;
        case 'title': case 'title_2':
            if (!value) {
                return 'Title is Required';
            }
            break;
        case 'date_of_birth': case 'date_of_birth_2':
            if (!value) {
                return 'Date of Birth is Required';
            }
            else if (value.length < 10 || value.includes("_")) {

                return 'Date of Birth is invalid';
            }
            var $arr = value.split('/');
            if ($arr[0] > 12 || $arr[1] > 31 || $arr[2] < 1900) {
                return 'Date of Birth is invalid';
            }
            break;
        case 'business_ownership': case 'business_ownership_2':
            var $total = 0;
            var own1 = parseInt(document.getElementsByName('business_ownership')[0].value);
            var own2 = parseInt(document.getElementsByName('business_ownership_2')[0].value);
            own2 = own2 ? own2 : 0;
            $total += (own1 + own2);
            if (!value) {
                return 'Business Ownership is Required';
            } else if ($total > 100)
                return 'Business Ownership cannot exceed 100%!';
            break;


        case 'business_product_sold':
            if (!value || value === '') {
                return 'The product sold is required';
            }
            break;


        default:
            break;
    }
};
function isImage(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
        case 'jpg':
        case 'png':
        case 'pdf':
            return true;
        default:
            return false;
    }

}
function getExtension(filename) {
    var fileName = filename.name;
    var parts = fileName.substr(fileName.lastIndexOf('.') + 1);
    return parts;
}

function isValidSSN(value) {
    var ssnPattern = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/;
    var $result = ssnPattern.test(value);
    return $result;
}
function isLowerThan($file, $limit) {
    let $fileSize = 0;
    var $mb = ($fileSize + $file.size) / 1000000;
    if ($mb > $limit) {
        return (`${$file.name} exceeds allowed upload size of ${$limit}MB, please retry.`);
    }
    return false;
}
export default validate;